import { browser } from '$app/environment';

interface WeglotApi {
	initialized: boolean;
	getCurrentLang: () => string;
	getAvailableLanguages: () => string[];
	getLanguageName: (code: string) => string;
	switchTo: (lang: string) => void;
	on: (event: string, callback: () => void) => void;
}

declare global {
	interface Window {
		Weglot?: WeglotApi;
	}
}

let currentLanguage = $state<string | null>(null);
let availableLanguages = $state<string[]>([]);

function sync() {
	const weglot = window.Weglot;
	if (!weglot) return;

	currentLanguage = weglot.getCurrentLang();
	availableLanguages = weglot.getAvailableLanguages();
}

function waitForWeglot(attemptsLeft = 75) {
	if (!browser || attemptsLeft <= 0) return;

	const weglot = window.Weglot;
	if (!weglot) {
		setTimeout(() => waitForWeglot(attemptsLeft - 1), 200);
		return;
	}

	weglot.on('initialized', sync);
	weglot.on('languageChanged', sync);
	if (weglot.initialized) {
		sync();
	}
}

if (browser) {
	waitForWeglot();
}

export function getWeglotState() {
	return {
		currentLanguage() {
			return currentLanguage;
		},
		otherLanguages() {
			return availableLanguages.filter((lang) => lang !== currentLanguage);
		},
		languages() {
			return availableLanguages;
		},
		hasAlternates() {
			return currentLanguage !== null && availableLanguages.length > 1;
		},
		languageName(code: string) {
			return window.Weglot?.getLanguageName(code) ?? code.toUpperCase();
		},
		switchTo(lang: string) {
			window.Weglot?.switchTo(lang);
		}
	};
}
